import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import 'swiper/scss';
import 'swiper/scss/navigation';
import { useOnceInView } from '@elem/compPage/on-the-road-power-solution/pages/product/components/US/useOnceInView';

interface ItfItem {
    name: string;
    text: string;
    img: string;
}
const L: React.FC = () => {
    const { t } = useLang('stream.overview');
    const [gap, setGap] = useState(20);
    const [isCollapse, setIsCollapse] = useState(true);

    const items: ItfItem[] = [
        {
            name: t('L_item1_name'),
            text: t('L_item1_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774597004734/l1.jpg',
        },
        {
            name: t('L_item2_name'),
            text: t('L_item2_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774597004920/l2.jpg',
        },
        {
            name: t('L_item3_name'),
            text: t('L_item3_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774597005299/l3.jpg',
        },
        {
            name: t('L_item4_name'),
            text: t('L_item4_text'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1774597005073/l4.jpg',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth > 1440) setGap(24);
            if (window.innerWidth >= 1024) setGap(20);
            if (window.innerWidth < 1024) setGap(12);
        }
    }, []);

    useOnceInView('.stream-nl-L .title', () => {
        document.querySelector('.stream-nl-L .title')?.classList.add('enter');
        document.querySelector('.stream-nl-L .desc')?.classList.add('enter');
        document.querySelector('.stream-nl-L .items')?.classList.add('enter');
    });

    return (
        <div className={`${css.section} stream-nl-L GtmModuleData-section space white`} id="stream-nl-L" data-section-id={'stream-nl-L'}>
            <div className="info">
                <h2 className="title ani-1">{t('L_title')}</h2>
                <p className="desc ani-2">
                    {t.rich('L_desc', {
                        b: (tx: string) => <span className="b">{tx}</span>,
                    })}
                </p>
            </div>
            <Swiper modules={[Navigation]} slidesPerView={'auto'} spaceBetween={gap} className="items ani-3" navigation={true}>
                {items?.map((item: ItfItem) => (
                    <SwiperSlide className="item" key={item.name}>
                        <EcoImg className="item-img" pc={item.img} alt={item.name} />
                        <div className={`item-info ${isCollapse ? 'close' : 'open'}`}>
                            <p className="item-name">{item.name}</p>
                            <p className="item-text">{item.text}</p>
                            <div className={`more-less`} onClick={() => setIsCollapse(!isCollapse)}>
                                <span>{isCollapse ? t('L_more') : t('L_less')}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path
                                        d="M9.92529 14.4453C9.65744 14.4453 9.40084 14.3378 9.21289 14.147L2.71289 7.54688L4.1377 6.14356L9.92529 12.0205L15.7129 6.14356L17.1377 7.54688L10.6377 14.147L10.564 14.2148C10.3853 14.3631 10.1596 14.4453 9.92529 14.4453Z"
                                        fill="black"
                                    />
                                </svg>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default L;
